<template>
  <sub-heading class="text-uppercase mb-1 text-disabled">
    Lignende produkter
  </sub-heading>
  <v-row>
    <v-col cols="6" v-for="(product, pIdx) in recommended" :key="pIdx">
      <product-card
        :to="{...RouteName.website.product.show, params: {
            brand: product.brand.slug,
            product: product.slug,
          }}"
        :product="product"
        :brand="product.brand"
      />
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import SubHeading from "@/components/typography/sub-heading.vue";
import {Product} from "@/lib/keys";
import {useProductStore} from "@/store/product";
import {onMounted, ref, unref, watch} from "vue";
import ProductCard from "@/components/shared/product/product-card.vue";
import {RouteName} from "@/keys";
import {useRoute} from "vue-router";


const props = withDefaults(defineProps<{
  product: Product;
  limit?: number;
}>(), {
  limit: 2,
});

const productStore = useProductStore();
const route = useRoute();

const recommended = ref<Product[]>([]);

const loadRecommended = () => {
  if (!props.product.cuid || !props.product.related || props.product.related.length <= 2) {
    recommended.value = unref(productStore.products)
      .filter(
        p => p.slug !== props.product.slug && p.id !== props.product.id,
      )
      .sort((a, b) => {
        return a.name
          .replace(a.brand.name, '')
          .replace(/\d+/, '')
          .trim()
          .localeCompare(
            b.name
              .replace(b.brand.name, '')
              .replace(/\d+/, '')
              .trim()
              .toLowerCase(),
          );
      }).slice(0, props.limit);
    return;
  }

  recommended.value = unref(productStore.products)
    .filter(p => {
      if (!props.product.related || !p.cuid) {
        return false;
      }
      return props.product.related.includes(p.cuid);
    })
    .slice(0, props.limit);
};


onMounted(loadRecommended);

watch(() => route.path, loadRecommended);
</script>
